import React from "react";
import { OutputSettingProps } from "../../../../Types/Workflow-Types";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";

const OutputSettingImage = ({readOnly}:OutputSettingProps) => {
  return (
    <span className="typeInput-output" style={{ opacity:0.7 }}>
      <span className="me-1">
        <ImageOutlinedIcon
          className={`app-icon Image`}
        sx={{ fontSize:"20px",}}
        />
      </span>
      <span className="ms-1">Image</span>
    </span>
  );
};

export default OutputSettingImage;
